<template>
  <div class="common-multiline" style="z-index: 666">
    <div v-resize="resizeChart" :id="commonMultilineId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../../utils/util"
  export default {
    name: 'common-multiline',
    props: {
      commonMultilineId: {
        type: String,
        default () {
          return 'commonMultilineId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '100%'
        }
      },
      multilineTitle: {
        type: String,
        default () {
          return ''
        }
      },
      titleStyle: {
        type: Object,
        default () {
          return  {}
        }
      },
      multilineColor: {
        type: Array,
        default () {
          return []
        }
      },
      legendData: {
        type: Object,
        default () {
          return  {}
        }
      },
      multilineXAxis: {
        type: Array,
        default () {
          return []
        }
      },
      multilineYAxis: {
        type: Array,
        default () {
          return [
            {
              type: 'value',
              nameTextStyle: {
                color: '#ffffff',
              },
              axisLine:{
                lineStyle:{
                  color:'#ffffff',
                }
              },
              splitLine: {
                show: false
              },
              minInterval: 1,
            }
          ]
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        commonMultiline: null
      }
    },
    mounted () {
      this.drawMultiline()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    directives:{
      resize: { // 指令的名称
        bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
          console.log(el,"绑定",binding);
          let width = '', height = '';
          function isReize() {
            const style = document.defaultView.getComputedStyle(el);
            if (width !== style.width || height !== style.height) {
              binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
            }
            width = style.width;
            height = style.height;
          }
          el.__vueSetInterval__ = setInterval(isReize, 300);
        },
        unbind(el) {
          console.log(el,"解绑");
          clearInterval(el.__vueSetInterval__);
        }
      }
    },
    methods: {
      drawMultiline () {
        this.commonMultiline = this.$echarts.init(document.getElementById(this.commonMultilineId))
        this.commonMultiline.setOption({
          title: {
            text: this.multilineTitle,
            show: false,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          color: this.multilineColor,
          legend: this.legendData,
          grid: {
            top: '30px',
            left: '10px',
            right: '20px',
            bottom: '3%',
            containLabel: true
          },
          xAxis: this.multilineXAxis,
          yAxis: this.multilineYAxis,
          series: this.series,
        })
      },
      resizeChart: debounce(function () {
        this.commonMultiline.resize()
      }, 100)
    },
    watch: {
      series (val) {
        this.drawMultiline()
      }
    }
  }
</script>

<style scoped>
  .common-multiline {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Multiline/CommonMultiline.vue